<template>
  <div>
    <b-row class="justify-content-center mb-4">
      <b-col cols="12" sm="6">
        <label>{{ $t(name) }}</label>
        <ValidationProvider
          ref="vee-building-name"
          v-slot="{ errors, classes }"
          :name="'name'"
          rules="required"
        >
          <b-input :value="building.name" @input="updateBuilding('name', $event)" />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
    </b-row>
    <b-row class="justify-content-center">
      <b-col cols="12" sm="6">
        <label>{{ $t(description) }}</label>
        <b-textarea :value="building.address" @input="updateBuilding('address', $event)" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    building: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    isAsl() {
      return this.$route.path.includes("asl");
    },
    name() {
      if (this.isAsl) {
        return "catalogs.Le_nom_du_asl";
      } else {
        return "catalogs.Le_nom_du_copropriété";
      }
    },
    description() {
      if (this.isAsl) {
        return "catalogs.Ladresse_du_asl";
      } else {
        return "catalogs.Ladresse_du_copropriété";
      }
    },
  },
  methods: {
    updateBuilding(key, value) {
      this.$emit("updateBuilding", key, value);
    },
  },
};
</script>
